import { Suspense } from 'react';

import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import i18n from 'config/i18n.ts';
import { setDefaultOptions } from 'date-fns';
import { ko } from 'date-fns/locale/ko';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { Splash } from './components/ui/Splash';
import { ThemeProvider } from './modules/common/context/ThemeProvider';
import { Routes } from './routes';

import 'dayjs/locale/ko';
import './libs/styles/antd.less';
import './libs/styles/tailwind.css';
import './libs/styles/global.css';
import './libs/styles/layout.css';

dayjs.locale('ko');
dayjs.extend(updateLocale);
dayjs.extend(isBetween);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

setDefaultOptions({
  locale: ko,
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      gcTime: 1000 * 60 * 60 * 24, // 1440분(24시간)
    },
  },
});

// 변수를 동적으로 설정하고자 할 때 사용

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <Suspense fallback={<Splash />}>
    {/* <GlobalStyle /> */}
    <I18nextProvider i18n={i18n}>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister }}
        onSuccess={() => {
          // resume mutations after initial restore from localStorage was successful
          queryClient.resumePausedMutations().then(() => {
            queryClient.invalidateQueries();
          });
        }}
      >
        <ThemeProvider>
          <Routes />
        </ThemeProvider>
      </PersistQueryClientProvider>
    </I18nextProvider>
  </Suspense>,
  // </React.StrictMode>,
);
